import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

const Divider = ({ marginY }: { marginY?: 'small' | 'medium' | 'large' }) => {
  return (
    <div
      className={clsx(
        {
          [styles[`${marginY}MarginY`]]: marginY,
        },
        'Divider'
      )}
    ></div>
  );
};

export default Divider;
